export default {"src":"/_next/static/media/promote-fundraisers-icon.ae02109e.svg","height":125,"width":140,"blurWidth":0,"blurHeight":0};